import AssignmentRequest from '@/services/assignment_request'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    AssignmentRequest.fetch().then((response) => {
      commit('SET_LIST', response.data.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchAssignmentRequestStatus = async (context) => {
  return new Promise((resolve, reject) => {
    AssignmentRequest.status().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const save = (context, payload) => {
  return new Promise((resolve, reject) => {
    AssignmentRequest.save(payload).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

export default {
  save,
  fetch,
  fetchAssignmentRequestStatus
}



// WEBPACK FOOTER //
// ./src/features/assignment_request/store/actions.js